import { render, staticRenderFns } from "./OP_DxSummary.vue?vue&type=template&id=814970b6&scoped=true&"
import script from "./OP_DxSummary.vue?vue&type=script&lang=js&"
export * from "./OP_DxSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814970b6",
  null
  
)

export default component.exports